import { Pipe, PipeTransform } from '@angular/core';
import { LocationType } from '../../../../../app/models';

const LOCATION_TYPE_LIST = LocationType.LocationTypeList;

@Pipe({
  name: 'locationTypePipe',
  standalone: true,
})
export class LocationTypePipe implements PipeTransform {
  transform(locationTypeId: number): string {
    const value = LOCATION_TYPE_LIST.find(
      (type) => type.value === locationTypeId
    );
    return value.name || '';
  }
}
